type TFeatureItem = {
  title: string
  description: string
}

const FEATURES: TFeatureItem[] = [
  {
    title: '24/7 Customer Support',
    description: 'Never miss a customer inquiry again',
  },
  {
    title: 'Instant Responses',
    description: 'Reduce response time from hours to seconds',
  },
  {
    title: 'Lead Qualification',
    description: 'Automatically qualify and route leads',
  },
  {
    title: 'Appointment Booking',
    description: 'Let customers book directly through chat',
  },
]

export default FEATURES
